import { TextField } from "@mui/material";
import { useSelector } from "react-redux";
import { useAppDispatch } from "../../redux/store";
import { formatNumberHalfWidth } from "../../util/utils";
import { setEventItem } from "../../redux/Reducers/createPostReducer";
import { postalCodeValidate } from "../../util/CreatePost/validator";
import { styles } from "./CreatePostStyles";
import Section from "./Section";
import { T, TF } from "react-translator-component";

export default function EventLocation() {
  const dispatch = useAppDispatch();

  const postEvent = useSelector((state: any) => state.createPost.values.event);
  const venueName = postEvent.venueName;
  const postalCode = postEvent.postalCode;
  const address = postEvent.address;
  const errors = useSelector((state: any) => state.createPost.errors.event);

  const handleChangePostalCode = (e: any) => {
    let value = e.target.value

    value = formatNumberHalfWidth(value)

    const item = {
      key: 'postalCode',
      value: postalCode,
      error: ''
    }

    if (value.length > 7) {
      if (postalCode.length > value.length) item.value = value;
      item.error = TF(T("error_postal_code"), 8);
      dispatch(setEventItem(item));
      return
    }

    const validateResult = postalCodeValidate(value)

    if (!validateResult.valid) {
      item.error = validateResult.error;
    }
    item.value = e.target.value;
    dispatch(setEventItem(item));
  }

  return (
    <Section
      title={`${T("event_location")}${T("required")}`}
      body={
        <>
          <TextField
            style={styles.textField}
            onChange={(e) => dispatch(setEventItem({key: 'venueName', value: e.target.value}))}
            value={venueName}
            placeholder={`${T("venue_name")}`}
            multiline
            rows={1}
            variant="outlined"
            fullWidth
            error={!!errors.venueName}
            helperText={errors.venueName}
          />
          <TextField
            style={styles.textField}
            onChange={(e) => handleChangePostalCode(e)}
            value={postalCode}
            placeholder={`${T("postal_code")}${T("postal_code_placeholder")}`}
            multiline
            rows={1}
            variant="outlined"
            fullWidth
            error={!!errors.postalCode}
            helperText={errors.postalCode}
            inputProps={{ inputMode: 'numeric' }}
          />
          <TextField
            style={styles.textField}
            onChange={(e) => dispatch(setEventItem({key: 'address', value: e.target.value}))}
            value={address}
            placeholder={`${T("address")}`}
            multiline
            rows={1}
            variant="outlined"
            fullWidth
            error={!!errors.address}
            helperText={errors.address}
          />
        </>
      }
    />
  )
}
